module.exports = __webpack_public_path__ + "img/logo-spotify.4bb67532.svg";